import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <section class=\"row overview-accordion-content-module\">\n    <div class=\"row\">\n      <div class=\"main large-10 medium-10 large-offset-1 column\">\n        <div class=\"show-for-small-only social-mobile\">\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"children") : depths[1])) != null ? lookupProperty(stack1,"shareMobileTop") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":10},"end":{"line":8,"column":85}}})) != null ? stack1 : "")
    + "\n        </div>\n        <div class=\"content cnx-regular\">\n          "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"text") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n      </div>\n      <div class=\"large-1 medium-1 column show-for-medium-up\">\n        <div class=\"social-vertical show-for-medium-up\">\n          <div>\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[1] != null ? lookupProperty(depths[1],"children") : depths[1])) != null ? lookupProperty(stack1,"shareTop") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":12},"end":{"line":17,"column":75}}})) != null ? stack1 : "")
    + "\n          </div>\n        </div>\n      </div>\n    </div>\n    </section>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"children") : depths[1])) != null ? lookupProperty(stack1,"shareMobileTop") : stack1), depth0)) != null ? stack1 : "")
    + " ";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"children") : depths[1])) != null ? lookupProperty(stack1,"shareTop") : stack1), depth0)) != null ? stack1 : "")
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"local") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":23,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/overview-content-module",
  "version": "1.0.1",
  "id": "overviewContentModule",
  "containerID": "homeLoansOverviewContentModule",
  "moduleName": "home-loans-overview-content-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "overview-content-module",
  "data": {
    "init": "overviewContentModuleJS",
    "options": {}
  },
  "moduleParams": [{}],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/*
 * overview-content-module
 * module_js_id: overviewContentModuleJS
 *
 * Copyright (c) 2017-1-2
 */

/**
 * @export
 * @class overviewContentModuleJS
 * @extends Module
 */
class overviewContentModuleJS extends Module {
  /**
   * Initialize the module
   * @method constructor
   * @param {object} options options object
   * @param {object} context context object
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('.overview-content-module');
  }

  /**
   * Initialize the module
   * @method init
   * @desc Initialize module
   * @memberof overviewContentModuleJS
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: overviewContentModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { overviewContentModuleJS as default, moduleConfig };
